<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('BusinessIntelligence.businessIntelligenceChartTab')" name="businessIntelligenceChart" :lazy="true">
          <business-Intelligence-Chart ref="businessIntelligenceChart" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['role_biConfig_toView'])" :label="$t('BusinessIntelligence.businessIntelligenceDashboardTab')" name="businessIntelligenceDashboard" :lazy="true">
          <business-Intelligence-Dashboard :entrance="entrance" />
        </el-tab-pane>
        <el-tab-pane :label="$t('BusinessIntelligence.chartGroupSettingTab')" name="chartGroupSetting" :lazy="true">
          <chart-Group-Setting ref="chartGroupSetting" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import businessIntelligenceChart from './components/businessIntelligenceChart'
import businessIntelligenceDashboard from '@/views/cargo/v0/BiAnalysis/businessIntelligenceDashboard'
import chartGroupSetting from './components/chartGroupSetting'
export default {
  name: 'BusinessIntelligence',
  components: { businessIntelligenceChart, businessIntelligenceDashboard, chartGroupSetting },
  data() {
    return {
      activeTabName: 'businessIntelligenceChart',
      entrance: 'TAB'
    }
  },
  methods: {
    handleClick(tab, event) {
      switch (tab.name) {
        case 'chartGroupSetting':
          this.$nextTick(() => {
            this.$refs['chartGroupSetting'].getList()
            this.$refs['chartGroupSetting'].init()
          })
          break
        case 'businessIntelligenceChart':
          this.$refs['businessIntelligenceChart'].getGroupList()
          break
      }
    }
  }
}
</script>
